<script setup lang="ts">
import { ALERT_STATUS } from "~/common/interfaces/alert-status.enum";
import { useAlertStore } from "~/stores/alert";
import { useMaterialsStore } from "~/stores/materials";
import { useModalStore } from "~/stores/modal";

const { t } = useI18n();
const route = useRoute();
const alertStore = useAlertStore();
const { materialsConfirmDelete } = useModalStore();
const materialsStore = useMaterialsStore();

const submitMaterialDelete = async () => {
	await materialsStore.deleteById(materialsConfirmDelete.material.id);

	materialsConfirmDelete.closeModal();

	if (route.name === "components-materials-material") {
		navigateTo("/components/materials");
	} else if (route.name === "components-materials") {
		materialsStore.getAll({}, materialsStore.recentGetAllQuery);
	}

	alertStore.addAlert({
		title: t("COMPONENTS.MATERIALS.CONFIRM_DELETE.alert.title"),
		description: t("COMPONENTS.MATERIALS.CONFIRM_DELETE.alert.description", { materialName: materialsConfirmDelete.material.name }),
		status: ALERT_STATUS.SUCCESS
	});
};
</script>

<template>
	<AppModalConfirm
		:title="$t('COMPONENTS.MATERIALS.CONFIRM_DELETE.title')"
		:description="$t('COMPONENTS.MATERIALS.CONFIRM_DELETE.description', { materialName: materialsConfirmDelete.material.name })"
		:close-button-text="$t('COMMON.noCancel')"
		:submit-button-text="$t('COMMON.yesDelete')"
		@close="materialsConfirmDelete.closeModal"
		@submit="submitMaterialDelete"
	/>
</template>
